import { Image, Text, View } from "@react-pdf/renderer";
import { styles } from "../styles";

export function GraphViewer({
  graphcs,
  sharedOptions,
  description,
  font,
  options = {},
}) {
  return (
    <View
      key={"boolean-top2"}
      style={{
        display: "flex",
        flexDirection: "column",
        marginVertical: 10,
        width: "500px",
        ...options?.container,
      }}
      wrap={false}
    >
      <View style={{ ...styles.stylesReportIntro.rowView, ...options?.header }}>
        <Text
          style={styles.legendBold}
        >{`Gráfico ${sharedOptions?.countGraphcs}: `}</Text>

        <Text style={styles.legend}>{description}</Text>
      </View>
      <Image
        key={"iamge2"}
        style={{ height: "auto", width: "100%", ...options?.img }}
        src={`data:application/pdf;base64,${graphcs}`}
      />
      {(sharedOptions.countGraphcs += 1)}
      <View style={{ ...styles.stylesReportIntro.rowView, ...options?.footer }}>
        <Text style={styles.legend}>{font}</Text>
      </View>
    </View>
  );
}
